export default [
  {
    service: 'initThenStartCheckout',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/checkout/init-then-start',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  },
  {
    service: 'continueCheckout',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/checkout/continue',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  },
  {
    service: 'getOrderInfo',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/pending-order',
    method: 'get',
    responseType: 'json',
  },
  {
    service: 'getAnalyticsInfo',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/checkout-analytics',
    method: 'get',
    responseType: 'json',
  },
  {
    service: 'checkoutNow',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/pending-order/checkout',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
  {
    service: 'checkEmailExist',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/user/username',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    isSupportLoader: false,
    queryType: 'mutation',
  },
  {
    service: 'applyCoupon',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/coupon/apply',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
  {
    service: 'applyTransferFee',
    url: '{widgetAPIServerHost}/checkout/rest/v2/transactions/{accessToken}/transfer-fee/apply',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    responseType: 'json',
    queryType: 'mutation',
  },
];
